import React, { useState } from 'react'
import { Page } from 'pages'
import { AssessmentDefs } from 'pages'
import { useNavigate, useParams } from 'react-router-dom'
import { app, assessments } from 'router/routes'
import { ratingRQ } from 'store/hooks'
import { queryClient as qc } from 'keys'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getMatchingLearningFetch } from 'store/middlewares/rating.crud'
import { Title as ScreenTitle } from 'components'
import AssessmentDetails from 'pages/School/Assessment/AssessmentDetails'

const MatchingLearning = (props) => {
    const navigate = useNavigate()
    const [assessmentFilters, setAssessmentFilters] = useState({
        category: null
    })
    const params = useParams()

    const { } = ratingRQ.useGetRating()
    const { assessment } = useSelector(state => state.assessment)
    const { rating } = useSelector(state => state.rating)

    const assessmentDefs = useQuery({
        enabled: !!rating,
        queryKey: [qc.matchingLearning, params.assessmentID, rating],
        queryFn: async ({ signal }) => {
            const { data } = await getMatchingLearningFetch({ signal, rating, assessmentFilters })
            return data
        }
    })

    const goAssessmentDef = ({ id }) => navigate(`${app.assessmentDefs}/${id}`)

    return (
        <Page>
            <ScreenTitle {...props} breadcrumbs={true} featurePath={`${assessments}/${params.assessmentID}`}>
                <div className='bread-crumbs-title'>
                    <div>{">"}</div>
                    {"קריאה מותאמת"}
                </div>
            </ScreenTitle>
            <AssessmentDetails />
            <AssessmentDefs
                hideFilters
                shouldUseParentData={true}
                onSelectAssessment={goAssessmentDef}
                assessments={assessmentDefs}
                assessmentFilters={assessmentFilters}
                setAssessmentFilters={setAssessmentFilters}
            />
        </Page>
    )
}

export default MatchingLearning